module.exports = __webpack_public_path__ + "static/media/f606478923a4ba7f25c841e13769f387_html_9c51db1c2ef9b5e7.46153a6f.png";